import { render, staticRenderFns } from "./long-boss.vue?vue&type=template&id=510f3e9c&"
import script from "./long-boss.vue?vue&type=script&lang=js&"
export * from "./long-boss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports